import { useQuery } from '@apollo/client';
import { NextPageWithLayout } from '@scorenco/next';
import { useRouter } from 'next/router';

import { WidgetsStyle } from '@/components';

import { RankingWidget } from '../../components/Widgets';
import { WidgetsLayout } from '../../layouts';
import { GetWidgetDocument } from '../_internal/Widget.query.generated';

const WidgetRanking: NextPageWithLayout = () => {
  const router = useRouter();

  const getWidget = useQuery(GetWidgetDocument, {
    variables: {
      widgetId: Number(router.query.widgetId),
      cacheTTL: router.query.noCache ? 0 : undefined,
    },
    skip: !router.query.widgetId,
    context: {
      role: 'anonymous',
    },
  });

  const widget = getWidget.data?.widgets_widget_by_pk;
  const teams = widget?.team_detail_list;

  return (
    <WidgetsStyle widget={widget}>
      <RankingWidget teams={teams} />
    </WidgetsStyle>
  );
};

export const getStaticPaths = WidgetsLayout.buildGetStaticPaths();

export const getStaticProps = WidgetsLayout.buildGetStaticProps({
  i18n: { namespaces: ['common'] },
});

WidgetRanking.getLayout = WidgetsLayout.buildGetLayout();

export default WidgetRanking;
